import React from 'react';
import {
  Redirect,
  Route as ReactDomRoute,
  RouteProps as ReactDomRouteProps,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import AuthLayout from '../pages/_layouts/auth';
import DefaultLayout from '../pages/_layouts/default';

interface RouteProps extends ReactDomRouteProps {
  component: React.ComponentType;
  isPrivate?: boolean;
  enabledPermissions?: Array<string>;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  enabledPermissions = null,
  component: Component,
  ...rest
}) => {
  const { checkPermission, isAuthenticated, user } = useAuth();

  const Layout = isAuthenticated() ? DefaultLayout : AuthLayout;

  let enabled = true;
  const defaultPath = isAuthenticated() ? '/processes' : '/';

  let redirectPath = isPrivate ? '/' : defaultPath;

  if (isAuthenticated() && isPrivate && enabledPermissions !== null) {
    enabled = checkPermission(enabledPermissions);

    if (!enabled) {
      redirectPath = '/forbidden';
    }
  }

  return (
    <ReactDomRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === (isAuthenticated() && enabled) ? (
          (user && !user.mustChangePassword) ||
          (user &&
            user.mustChangePassword &&
            location.pathname === '/processes') ||
          !user ? (
            <Layout>
              <Component />
            </Layout>
          ) : (
            <Redirect to="/processes" />
          )
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
